/**
 * Detect Browser type and version
 */
var BrowserDetect = {
    init: function() {
        this.browser = this.searchString(this.dataBrowser) || "Other";
        this.version = this.searchVersion(navigator.userAgent) || this.searchVersion(navigator.appVersion) || "Unknown";
    },
    searchString: function(data) {
        for (var i = 0; i < data.length; i++) {
            var dataString = data[i].string;
            this.versionSearchString = data[i].subString;

            if (dataString.indexOf(data[i].subString) !== -1) {
                return data[i].identity;
            }
        }
    },
    searchVersion: function(dataString) {
        var index = dataString.indexOf(this.versionSearchString);
        if (index === -1) {
            return;
        }

        var rv = dataString.indexOf("rv:");
        if (this.versionSearchString === "Trident" && rv !== -1) {
            return parseFloat(dataString.substring(rv + 3));
        } else {
            return parseFloat(dataString.substring(index + this.versionSearchString.length + 1));
        }
    },

    dataBrowser: [
        { string: navigator.userAgent, subString: "Chrome", identity: "Chrome" },
        { string: navigator.userAgent, subString: "MSIE", identity: "Explorer" },
        { string: navigator.userAgent, subString: "Trident", identity: "Explorer" },
        { string: navigator.userAgent, subString: "Firefox", identity: "Firefox" },
        { string: navigator.userAgent, subString: "Safari", identity: "Safari" },
        { string: navigator.userAgent, subString: "Opera", identity: "Opera" }
    ]

};

BrowserDetect.init();

/*
 *  detect mobile device
 */
var isMobile = {
    Android: function() {
        return /Android/i.test(navigator.userAgent);
    },
    BlackBerry: function() {
        return /BlackBerry/i.test(navigator.userAgent);
    },
    iOS: function() {
        return /iPhone|iPad|iPod/i.test(navigator.userAgent);
    },
    Windows: function() {
        return /IEMobile/i.test(navigator.userAgent);
    },
    any: function() {
        return (isMobile.Android() || isMobile.BlackBerry() || isMobile.iOS() || isMobile.Windows());
    }
};



/*
 *  Project: HelloPlace Inmobiliaria
 *  Description: Empresa de Bienes Raices
 *  Author: Edward Bentinck <edbentink@gmail.com>
 *  License: MIT
 */

// the semi-colon before function invocation is a safety net against concatenated 
// scripts and/or other plugins which may not be closed properly.
;
(function($, window, document, undefined) {

    // undefined is used here as the undefined global variable in ECMAScript 3 is
    // mutable (ie. it can be changed by someone else). undefined isn't really being
    // passed in so we can ensure the value of it is truly undefined. In ES5, undefined
    // can no longer be modified.

    // window and document are passed through as local variables rather than globals
    // as this (slightly) quickens the resolution process and can be more efficiently
    // minified (especially when both are regularly referenced in your plugin).

    // Create the defaults once
    var pluginName = 'helloplace',
        document = window.document,
        defaults = {
            screen: (BrowserDetect.browser == 'Explorer' || BrowserDetect.browser == 'Firefox') ? $("html") : $("body")
        };

    // The actual plugin constructor
    var Plugin = function(element, options) {
        this.element = element;

        // jQuery has an extend method which merges the contents of two or 
        // more objects, storing the result in the first object. The first object
        // is generally empty as we don't want to alter the default options for
        // future instances of the plugin
        this.options = $.extend({}, defaults, options);

        this._defaults = defaults;
        this._name = pluginName;

        this.init(this.options);
    }

    Plugin.prototype = {
        // Place initialization logic here
        // You already have access to the DOM element and the options via the instance, 
        // e.g., this.element and this.options

        init: function(options) {
            $.extend(this.options, options);
            this.Screen = options.screen;
            this.watchScrolling();
        },

        watchScrolling: function() {
            var Screen = this.Screen,
                $pageHead = $('.c-page-head'),
                $pageHeadClass = 'c-page-head--white',
                _viewportHeight = $(window).height(),
                _navbarHeight = $pageHead.height();

            $(window).scroll(function() {
                var _scrolled = Screen.scrollTop(); // $('body').scrollTop() || $('html').scrollTop();

                if (_scrolled > (_viewportHeight - _navbarHeight)) $pageHead.addClass($pageHeadClass);
                else $pageHead.removeClass($pageHeadClass);
            });

        }

    };

    // A really lightweight plugin wrapper around the constructor, 
    // preventing against multiple instantiations
    $.fn[pluginName] = function(options) {
        return this.each(function() {
            if (!$.data(this, 'plugin_' + pluginName)) {
                $.data(this, 'plugin_' + pluginName, new Plugin(this, options));
            }
        });
    };

}(jQuery, window, document));

$.fn.fillViewportHeight = function() {
    return this.each(function() {
        var _viewportHeight = $(window).height(),
            $pageHead = $('.c-page-head'),
            _navbarHeight = $pageHead.height();
        $(this).height(_viewportHeight - _navbarHeight);
    });
};

/**
 * Helloplace document scripts
 */
$(document).ready(function() {

    /**
     * Ensure that the hero fills the height of the viewport
     */
    var _resizeHeroToFitViewport = function() {
        $('.js-fill-viewport').fillViewportHeight();
    };
    _resizeHeroToFitViewport();

    $(".js-tel-input").keydown(function (e) {
        // Allow: backspace, delete, tab, escape, enter, - and space
        if ($.inArray(e.keyCode, [46, 8, 9, 27, 13, 110, 189, 32]) !== -1 ||
             // Allow: Ctrl+A || Cmd+A
            (e.keyCode == 65 && (e.ctrlKey === true || e.metaKey === true)) ||
             // Allow: Ctrl+C || Cmd+C
            (e.keyCode == 67 && (e.ctrlKey === true || e.metaKey === true)) ||
             // Allow: Ctrl+V || Cmd+V
            (e.keyCode == 86 && (e.ctrlKey === true || e.metaKey === true)) ||
             // Allow: Ctrl+X || Cmd+X
            (e.keyCode == 88 && (e.ctrlKey === true || e.metaKey === true)) ||
             // Allow: Shift+\+
            (e.keyCode == 187 && (e.shiftKey === true)) ||
             // Allow: home, end, left, right
            (e.keyCode >= 35 && e.keyCode <= 39)) {
                 // let it happen, don't do anything
                 return;
            }

        // Stop the keypress if it's not a number
        if ((e.shiftKey || (e.keyCode < 48 || e.keyCode > 57)) && (e.keyCode < 96 || e.keyCode > 105)) {
            e.preventDefault();
        }
    });

    /**
     * Non-mobile devices only
     */
    if (!isMobile.any()) {
        $('.c-page-head').helloplace(); // detect page scroll

        $(window).resize(function() {
            _resizeHeroToFitViewport();
        });
    }

});
